<template>
  <div class="sales-product-box mt30">
    <div class="common-form">设备统计</div>
    <div class="d-s-stretch bd-box">
      <div class="d-s-c d-c left-box">
        <!--汇总-->
        <Total></Total>

        <!--已付款设备-->
        <LineChart></LineChart>
      </div>
      <!--设备排行榜-->
      <Ranking></Ranking>
    </div>
  </div>
</template>

<script>
  import Total from './product/Total.vue';
  import LineChart from './product/LineChart.vue';
  import Ranking from './product/Ranking.vue'
  export default{
    components: {
      Total,
      LineChart,
      Ranking
    }
  }
</script>

<style lang="scss">
  .sales-product-box .bd-box{ border-top: 1px solid #EEEEEE;}
  .sales-product-box .left-box{ width: 69%; border-right: 1px solid #EEEEEE;}

  @media (max-width: 992px) {
    .sales-product-box .bd-box {
      flex-direction: column;
    }

    .sales-product-box .left-box {
      width: 100%;
      border-right: none;
      border-bottom: 1px solid #EEEEEE;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/statistics/sales/part/Product.vue